import { persistStateTypes } from 'a/reducers/persistStateReducer';
import { GAME_ID } from '../../data/constants';

const initialState = {
  onboardingCompleteArray: [],
  lastOnboardingLevel: 0,
};

const gameDetailsReducer = (state = initialState, { gameId, type, stateData }) => {
  if (gameId !== GAME_ID) return state;

  switch (type) {
    // update state when gamestate data has been received
    case persistStateTypes.REQUESTRESPONSE_GAMESTATE:
      return {
        ...state,
        ...(stateData[GAME_ID].GameData || state).gameDetails,
      };
    default:
      return state;
  }
};

export default gameDetailsReducer;
